import React from "react";
import BarcodeScanner10 from "./BarcodeScanner10";

export default function ScannerComponent(props) {
  const handleCapture = (result) => {
    props.onResult && props.onResult(result);
  };

  return (
    <div style={{ height: "100%", width: "100%", border: "2px solid red" }}>
      <BarcodeScanner10 onCapture={handleCapture} />
    </div>
  );
}
